<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("OTA_LOG") }}</h4>
    </div>
    <div class="grid-body border-top-unset">
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>
      <v-row class="pl-3 pr-3 pt-3">
        <v-col md="3" class="pt-0">
          <label>{{ $t("ROOM_NAME") }}</label>
          <v-select
            item-value="value"
            item-text="text"
            :items="listSelectRoomType"
            v-model="selectedRoomType"
            outlined
            dense
            :placeholder="$t('_BATCH_UPDATE.SELECT_ROOM_TYPE')"
          >
          </v-select>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("_SALE_PACKAGE.SALE_PACKAGE") }}</label>
          <v-select
            item-value="value"
            item-text="text"
            :items="listSelectRoomPlan"
            v-model="selectedRoomPlan"
            outlined
            dense
            :placeholder="$t('SELECT_SALE_PACKAGE')"
          >
          </v-select>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("SALE_CHANNEL") }}</label>
          <v-select
            item-value="value"
            item-text="text"
            :items="listSelectOTA"
            v-model="selectedOTA"
            outlined
            dense
            :placeholder="$t('SELECT_SALE_CHANNEL')"
          >
          </v-select>
        </v-col>
        <v-col md="3" class="pt-0">
          <label>{{ $t("DAY") }}</label>
          <date-picker
            :model.sync="selectedDatePicker"
            format="DD/MM/YYY"
            class="outlined"
            dense
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="mt-0 pl-3 pr-3 mb-3">
        <v-col md="6" class="pt-0">
          <label>{{ $t("MORE_OPTIONS") }}</label>
          <v-select
            item-text="text"
            item-value="value"
            :items="listFunction"
            v-model="selectedFunction"
            outlined
            dense
            multiple
            chips
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index === 0 || index === 1 || index === 2">
                <span>{{ item.text }}</span>
              </v-chip>
              <span v-if="index === 3" class="grey--text caption"
                >(+{{ selectedFunction.length - 3 }})</span
              >
            </template>
            <template slot="no-data">
              <div class="no-data">{{ $t("NO_DATA") }}</div>
            </template>
          </v-select>
        </v-col>
        <v-col class="pt-0 d-flex align-items-end justify-content-end">
          <v-btn class="btn-update" color="primary" @click="searchLog(1)">
            {{ $t("_BOOKING.SEARCH") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <template v-for="header in headers">
                <th
                  v-if="listFuns.includes(header.value)"
                  :class="header.class"
                >
                  <div>{{ header.text }}</div>
                </th>
              </template>
            </tr>
          </thead>
          <tbody>
            <template v-if="dataTable.length > 0 && !isLoading">
              <tr v-for="(item, i) in dataTable">
                <td class="text-center vertical-middle">
                  {{ paging.offset + i + 1 }}
                </td>
                <td class="vertical-middle">
                  {{ $t(item.status) }}
                </td>
                <td class="vertical-middle text-right">
                  {{
                    item.createDateTimeFromStart
                      ? _moment(item.createDateTimeFromStart).format(
                          " HH:mm:ss DD/MM/YYYY"
                        )
                      : "—"
                  }}
                </td>
                <td class="vertical-middle">
                  {{ $t("_BATCH_UPDATE.FROM") }}: {{ item.from }}<br />
                  {{ $t("_BATCH_UPDATE.TO") }}: {{ item.to }}
                </td>
                <td class="vertical-middle">
                  {{ item.data.inventory ? item.data.inventory : "—" }}
                </td>
                <td class="vertical-middle">
                  {{
                    item.data.sell_inventory ? item.data.sell_inventory : "—"
                  }}
                </td>
                <td class="vertical-middle text-right">
                  {{ item.data.rate ? formatCurrency(item.data.rate) : "—" }}
                </td>
                <td class="vertical-middle">
                  {{
                    item.data.stop_sell
                      ? item.data.stop_sell === "true"
                        ? $t("STOP_SELL")
                        : $t("UN_STOP_SELL")
                      : "—"
                  }}
                </td>
                <td class="vertical-middle">
                  {{
                    item.data.closed_on_arrival
                      ? item.data.closed_on_arrival === "true"
                        ? $t("_ROOM_PLAN.CTA")
                        : $t("OPEN_RESERVATION")
                      : "—"
                  }}
                </td>
                <td class="vertical-middle">
                  {{
                    item.data.closed_on_departure
                      ? item.data.closed_on_departure === "true"
                        ? $t("_ROOM_PLAN.CTD")
                        : $t("OPEN_CHECKOUT")
                      : "—"
                  }}
                </td>
                <td class="vertical-middle text-right">
                  {{ item.data.min_stay ? item.data.min_stay : "—" }}
                </td>
                <td class="vertical-middle text-right">
                  {{ item.data.max_stay ? item.data.max_stay : "—" }}
                </td>
                <td class="vertical-middle text-right">
                  <span v-if="item.data.extra_adult_rate">
                    {{ formatCurrency(item.data.extra_adult_rate) }} ({{
                      item.data.other
                    }})</span
                  >
                  <span v-else>—</span>
                </td>
                <td class="vertical-middle text-right">
                  <span v-if="item.data.extra_child_rate">
                    {{ formatCurrency(item.data.extra_child_rate) }} ({{
                      item.data.other
                    }})</span
                  >
                  <span v-else>—</span>
                </td>
                <td class="vertical-middle text-right">
                  <span v-if="item.data.extra_baby_rate">
                    {{ formatCurrency(item.data.extra_baby_rate) }} ({{
                      item.data.other
                    }})</span
                  >
                  <span v-else>—</span>
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('exact_stay')"
                >
                  {{ item.data.exact_stay ? item.data.exact_stay : "—" }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('exact_stay_arrival')"
                >
                  {{
                    item.data.exact_stay_arrival
                      ? item.data.exact_stay_arrival
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('min_stay_arrival')"
                >
                  {{
                    item.data.min_stay_arrival
                      ? item.data.min_stay_arrival
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('max_stay_arrival')"
                >
                  {{
                    item.data.max_stay_arrival
                      ? item.data.max_stay_arrival
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('min_booking_window')"
                >
                  {{
                    item.data.min_booking_window
                      ? item.data.min_booking_window + "D"
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('max_booking_window')"
                >
                  {{
                    item.data.max_booking_window
                      ? item.data.max_booking_window + "D"
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('min_booking_window_by_hour')"
                >
                  {{
                    item.data.min_booking_window_by_hour
                      ? item.data.min_booking_window_by_hour + "H"
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('max_booking_window_by_hour')"
                >
                  {{
                    item.data.max_booking_window_by_hour
                      ? item.data.max_booking_window_by_hour + "H"
                      : "—"
                  }}
                </td>
                <td
                  class="vertical-middle text-right"
                  v-if="listFuns.includes('rate_of_room_type')"
                >
                  <span v-if="item.data.rate_of_room_type">
                    {{ formatCurrency(item.data.rate_of_room_type) }}</span
                  >
                  <span v-else>—</span>
                </td>
                <td class="text-right vertical-middle">
                  <v-btn
                    class="mw-80"
                    color="success"
                    x-small
                    dark
                    @click="expandLogData(item)"
                  >
                    <span class="fs-10">{{ $t("_ROOM_SALE.EXPAND") }}</span>
                  </v-btn>
                  <br />
                  <v-btn
                    color="primary"
                    x-small
                    dark
                    @click="detailLogData(item)"
                    class="mt-2 mw-80"
                  >
                    <span class="fs-10">{{ $t("DETAIL") }}</span>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template v-else-if="!isLoading">
              <tr>
                <td
                  colspan="13"
                  class="text-center vertical-middle font-weight-bold font-italic text-danger"
                >
                  {{ $t("NO_DATA") }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>

      <paging
        v-if="paging.total"
        :paging.sync="paging"
        @changePage="changePage"
        class="pl-3 pr-3"
      >
        <span slot="totalItems" v-if="paging">
          {{ $t("TOTAL") }}: {{ $tc("ACTIVITY_LOG", paging.total) }}
        </span>
      </paging>
    </div>
    <v-dialog
      v-model="dialog"
      hide-overlay
      transition="dialog-bottom-transition"
      max-width="1000px"
    >
      <v-card class="overflow-hidden p-0">
        <v-app-bar
          absolute
          color="#fafafa"
          elevate-on-scroll
          scroll-target="#scrolling-techniques-7"
        >
          <v-toolbar-title class="label-title">{{
            $t("DETAIL")
          }}</v-toolbar-title>
        </v-app-bar>
        <v-sheet
          id="scrolling-techniques-7"
          class="overflow-y-auto fs-12 sheet-log"
          max-height="600"
        >
          <v-container class="mt-3">
            <label class="label-title">Request body: </label>
            <div class="ml-3" v-if="detailLog && detailLog.request_body">
              <pre>{{
                JSON.stringify(parseJison(detailLog.request_body), null, 2)
              }}</pre>
            </div>
            <v-divider />
            <label class="label-title">Request content type: </label>
            <div
              class="ml-3"
              v-if="detailLog && detailLog.request_content_type"
            >
              {{ detailLog.request_content_type }}
            </div>
            <v-divider />
            <label class="label-title">Request header: </label>
            <div class="ml-3" v-if="detailLog && detailLog.request_header">
              {{ detailLog.request_header }}
            </div>
            <v-divider />
            <label class="label-title">Request method: </label>
            <div class="ml-3" v-if="detailLog && detailLog.request_method">
              {{ detailLog.request_method }}
            </div>
            <v-divider />
            <label class="label-title">Request param: </label>
            <div class="ml-3" v-if="detailLog && detailLog.request_param">
              {{ detailLog.request_param }}
            </div>
            <v-divider />
            <label class="label-title">Request url: </label>
            <div class="ml-3" v-if="detailLog && detailLog.request_url">
              {{ detailLog.request_url }}
            </div>
            <v-divider />
            <label class="label-title">Response data: </label>
            <div class="ml-3" v-if="detailLog && detailLog.response_data">
              <pre>{{
                JSON.stringify(parseJison(detailLog.response_data), null, 2)
              }}</pre>
            </div>
          </v-container>
        </v-sheet>
      </v-card>
    </v-dialog>
    <!-- mo rong -->
    <v-dialog
      v-model="dialogExpand"
      hide-overlay
      transition="dialog-bottom-transition"
      max-width="1300px"
    >
      <v-card class="overflow-hidden p-0">
        <v-app-bar
          absolute
          color="#fafafa"
          elevate-on-scroll
          scroll-target="#scrolling-techniques-7"
        >
          <v-toolbar-title class="label-title">{{
            $t("_ROOM_SALE.EXPAND")
          }}</v-toolbar-title>
        </v-app-bar>
        <v-sheet
          id="scrolling-techniques-7"
          class="overflow-y-auto fs-12 sheet-log"
          max-height="600"
        >
          <v-container class="mt-3">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <template v-for="header in headers">
                      <th
                        :key="header.value"
                        v-if="
                          listFuns.includes(header.value) &&
                          header.value !== 'fullUpdate'
                        "
                        :class="header.class"
                      >
                        <div>{{ header.text }}</div>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <template v-if="dataTableExpand.length > 0 && !isLoading">
                    <tr v-for="(item, i) in dataTableExpand">
                      <td class="text-center vertical-middle">
                        {{ paging.offset + i + 1 }}
                      </td>
                      <td class="vertical-middle">
                        {{ $t(item.status) }}
                      </td>
                      <td class="vertical-middle text-right">
                        {{
                          item.createDateTimeFromStart
                            ? _moment(item.createDateTimeFromStart).format(
                                " HH:mm:ss DD/MM/YYYY"
                              )
                            : "—"
                        }}
                      </td>
                      <td class="vertical-middle">
                        {{ $t("_BATCH_UPDATE.FROM") }}: {{ item.from }}<br />
                        {{ $t("_BATCH_UPDATE.TO") }}: {{ item.to }}
                      </td>
                      <td class="vertical-middle">
                        {{ item.data.inventory ? item.data.inventory : "—" }}
                      </td>
                      <td class="vertical-middle">
                        {{
                          item.data.sell_inventory
                            ? item.data.sell_inventory
                            : "—"
                        }}
                      </td>
                      <td class="vertical-middle text-right">
                        {{
                          item.data.rate ? formatCurrency(item.data.rate) : "—"
                        }}
                      </td>
                      <td class="vertical-middle">
                        {{
                          item.data.stop_sell
                            ? item.data.stop_sell === "true"
                              ? $t("STOP_SELL")
                              : $t("UN_STOP_SELL")
                            : "—"
                        }}
                      </td>
                      <td class="vertical-middle">
                        {{
                          item.data.closed_on_arrival
                            ? item.data.closed_on_arrival === "true"
                              ? $t("_ROOM_PLAN.CTA")
                              : $t("OPEN_RESERVATION")
                            : "—"
                        }}
                      </td>
                      <td class="vertical-middle">
                        {{
                          item.data.closed_on_departure
                            ? item.data.closed_on_departure === "true"
                              ? $t("_ROOM_PLAN.CTD")
                              : $t("OPEN_CHECKOUT")
                            : "—"
                        }}
                      </td>
                      <td class="vertical-middle text-right">
                        {{ item.data.min_stay ? item.data.min_stay : "—" }}
                      </td>
                      <td class="vertical-middle text-right">
                        {{ item.data.max_stay ? item.data.max_stay : "—" }}
                      </td>
                      <td class="vertical-middle text-right">
                        <span v-if="item.data.extra_adult_rate">
                          {{ formatCurrency(item.data.extra_adult_rate) }} ({{
                            item.data.other
                          }})</span
                        >
                        <span v-else>—</span>
                      </td>
                      <td class="vertical-middle text-right">
                        <span v-if="item.data.extra_child_rate">
                          {{ formatCurrency(item.data.extra_child_rate) }} ({{
                            item.data.other
                          }})</span
                        >
                        <span v-else>—</span>
                      </td>
                      <td class="vertical-middle text-right">
                        <span v-if="item.data.extra_baby_rate">
                          {{ formatCurrency(item.data.extra_baby_rate) }} ({{
                            item.data.other
                          }})</span
                        >
                        <span v-else>—</span>
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('exact_stay')"
                      >
                        {{ item.data.exact_stay ? item.data.exact_stay : "—" }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('exact_stay_arrival')"
                      >
                        {{
                          item.data.exact_stay_arrival
                            ? item.data.exact_stay_arrival
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('min_stay_arrival')"
                      >
                        {{
                          item.data.min_stay_arrival
                            ? item.data.min_stay_arrival
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('max_stay_arrival')"
                      >
                        {{
                          item.data.max_stay_arrival
                            ? item.data.max_stay_arrival
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('min_booking_window')"
                      >
                        {{
                          item.data.min_booking_window
                            ? item.data.min_booking_window + "D"
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('max_booking_window')"
                      >
                        {{
                          item.data.max_booking_window
                            ? item.data.max_booking_window + "D"
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('min_booking_window_by_hour')"
                      >
                        {{
                          item.data.min_booking_window_by_hour
                            ? item.data.min_booking_window_by_hour + "H"
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('max_booking_window_by_hour')"
                      >
                        {{
                          item.data.max_booking_window_by_hour
                            ? item.data.max_booking_window_by_hour + "H"
                            : "—"
                        }}
                      </td>
                      <td
                        class="vertical-middle text-right"
                        v-if="listFuns.includes('rate_of_room_type')"
                      >
                        <span v-if="item.data.rate_of_room_type">
                          {{ formatCurrency(item.data.rate_of_room_type) }}
                        </span>
                        <span v-else>—</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td
                        colspan="13"
                        class="text-center vertical-middle font-weight-bold font-italic text-danger"
                      >
                        {{ $t("NO_DATA") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-container>
        </v-sheet>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Paging from "@/components/Utils/Paging.vue";
import { log } from "@/_services/Log/log.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";
import DatePicker from "@/components/Utils/DatePicker.vue";
import { _formatCurrency } from "@/_helpers/function.js";
import moment from "moment";
import { restriction } from "@/_services/SaleRoom/restriction.js";

export default {
  components: {
    paging: Paging,
    "date-picker": DatePicker,
  },
  data() {
    return {
      selectedDatePicker: null,
      dialog: false,
      dialogExpand: false,
      detailLog: null,
      systemLang: this.$i18n.locale,
      isLoading: false,
      headers: [
        {
          text: this.$t("STT"),
          value: "stt",
          class: "text-center",
        },
        {
          text: this.$t("STATUS"),
          value: "status",
          class: "",
        },
        {
          text: this.$t("UPDATE_TIME"),
          value: "createDateTimeFromStart",
          class: "text-right",
        },
        {
          text: this.$t("SOURCE"),
          value: "from",
          class: "",
        },
        {
          text: this.$t("INV"),
          value: "inv",
          class: "",
        },
        {
          text: this.$t("SELLINV"),
          value: "sellinv",
          class: "",
        },
        {
          text: this.$t("RATE"),
          value: "rate",
          class: "text-right",
        },
        {
          text: this.$t("STOP_SELL"),
          value: "stop_sell",
          class: " ",
        },
        {
          text: this.$t("CTA"),
          value: "closed_on_arrival",
          class: " ",
        },
        {
          text: this.$t("CTD"),
          value: "closed_on_departure",
          class: " ",
        },
        {
          text: this.$t("MIN_STAY"),
          value: "min_stay",
          class: "text-right",
        },
        {
          text: this.$t("MAX_STAY"),
          value: "max_stay",
          class: "text-right",
        },
        {
          text: this.$t("priceExtraAdult"),
          value: "extra_adult_rate",
          class: "text-right",
        },
        {
          text: this.$t("priceExtraChild"),
          value: "extra_child_rate",
          class: "text-right",
        },
        {
          text: this.$t("priceExtraBaby"),
          value: "extra_baby_rate",
          class: "text-right",
        },
        {
          text: this.$t("exactStay"),
          value: "exact_stay",
          class: "text-right",
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exact_stay_arrival",
          class: "text-right",
        },
        {
          text: this.$t("minStayArrival"),
          value: "min_stay_arrival",
          class: "text-right",
        },
        {
          text: this.$t("maxStayArrival"),
          value: "max_stay_arrival",
          class: "text-right",
        },
        {
          text: this.$t("minBookingWindow"),
          value: "min_booking_window",
          class: "text-right",
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "max_booking_window",
          class: "text-right",
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "min_booking_window_by_hour",
          class: "text-right",
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "max_booking_window_by_hour",
          class: "text-right",
        },
        {
          text: this.$t("HOTEL_ROOM_RATE"),
          value: "rate_of_room_type",
          class: "text-right",
        },
        {
          text: this.$t("FULL_UPDATE"),
          value: "fullUpdate",
          class: "text-right",
        },
      ],
      dataTable: [],
      dataTableExpand: [],
      listSelectRoomType: [],
      selectedRoomType: null,
      listSelectOTA: [],
      selectedOTA: null,
      listFunction: [
        {
          text: this.$t("exactStay"),
          value: "exact_stay",
        },
        {
          text: this.$t("exactStayArrival"),
          value: "exact_stay_arrival",
        },
        {
          text: this.$t("minStayArrival"),
          value: "min_stay_arrival",
        },
        {
          text: this.$t("maxStayArrival"),
          value: "max_stay_arrival",
        },
        {
          text: this.$t("minBookingWindow"),
          value: "min_booking_window",
        },
        {
          text: this.$t("maxBookingWindow"),
          value: "max_booking_window",
        },
        {
          text: this.$t("minBookingWindowByHour"),
          value: "min_booking_window_by_hour",
        },
        {
          text: this.$t("maxBookingWindowByHour"),
          value: "max_booking_window_by_hour",
        },
        {
          text: this.$t("HOTEL_ROOM_RATE"),
          value: "rate_of_room_type",
        },
      ],
      selectedFunction: [],
      listSelectRoomPlan: [],
      selectedRoomPlan: null,
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
      },
      funs: [
        "stt",
        "status",
        "createDateTimeFromStart",
        "from",
        "inv",
        "sellinv",
        "rate",
        "stop_sell",
        "closed_on_arrival",
        "closed_on_departure",
        "min_stay",
        "max_stay",
        "extra_adult_rate",
        "extra_child_rate",
        "extra_baby_rate",
        "fullUpdate",
      ],
      listFuns: [
        "stt",
        "status",
        "createDateTimeFromStart",
        "from",
        "inv",
        "sellinv",
        "rate",
        "stop_sell",
        "closed_on_arrival",
        "closed_on_departure",
        "min_stay",
        "max_stay",
        "extra_adult_rate",
        "extra_child_rate",
        "extra_baby_rate",
        "fullUpdate",
      ],
    };
  },
  watch: {
    selectedFunction(val) {
      this.listFuns = val.concat(this.funs);
    },
    selectedRoomType(val) {
      this.selectedRoomPlan = null;
      let listRatePlans = [];
      this.selectedOTA = null;
      this.hasRoomRate.forEach((r) => {
        if (val === r.id) {
          r.ratePlans.forEach((p) => {
            listRatePlans.push({
              value: p.id,
              text: p.i18ns.find((y) => y.lang == this.defaultI18n).name,
            });
          });
        }
      });
      this.listSelectRoomPlan = Array.from(
        new Set(listRatePlans.map(JSON.stringify))
      ).map(JSON.parse);
    },
    selectedRoomPlan(val) {
      const listOtas = [];
      this.selectedOTA = null;
      if (!val) return;
      this.hasRoomRate.forEach((r) => {
        if (this.selectedRoomType === r.id) {
          r.ratePlans.forEach((p) => {
            if (val === p.id) {
              p.roomRates.forEach((o) => {
                listOtas.push({
                  value: o.ota.id,
                  text: o.ota.otaI18n.find((y) => y.lang == this.defaultI18n)
                    .name,
                });
              });
            }
          });
        }
      });
      this.listSelectOTA = Array.from(
        new Set(listOtas.map(JSON.stringify))
      ).map(JSON.parse);
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async getAllRoomDefault() {
      await restriction.getAllRoomTyeHasRoomRate().then((res) => {
        if (res.responseCode == 0) {
          this.hasRoomRate = res.data;
          this.listSelectRoomType = [];
          this.listSelectRoomType = this.listSelectRoomType.concat(
            res.data.map((room) => {
              return {
                value: room.id,
                text: room.roomTypeI18n.find((x) => x.lang === this.defaultI18n)
                  .name,
              };
            })
          );
        }
      });
    },
    formatCurrency(amount) {
      return _formatCurrency(amount);
    },
    parseJison(data) {
      try {
        // Parse a JSON
        return JSON.parse(data);
      } catch (e) {
        return data;
      }
    },
    detailLogData(data) {
      log.getDetailLog(data).then((res) => {
        if (res.responseCode == 0) {
          this.detailLog = res.data.data;
          this.dialog = true;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    expandLogData(data) {
      const body = {
        id: data.processTrackingId,
        appliedDate: this.selectedDatePicker,
        roomTypeId: this.selectedRoomType,
        ratePlanId: this.selectedRoomPlan,
        otaId: this.selectedOTA,
      };
      log.getExpandLog(body).then((res) => {
        if (res.responseCode == 0) {
          this.dataTableExpand = res.data;
          this.dialogExpand = true;
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    initialize() {
      // let body_roomtype = {
      //   keyword: "",
      //   status: null,
      //   limit: 1000,
      //   offset: 0,
      //   orderBy: "active",
      //   asc: false
      // };

      // await service.getAllRooms(body_roomtype).then(res => {
      //   if (res.responseCode == 0) {
      //     res.data.forEach(x => {
      //       this.listSelectRoomType.push({
      //         value: x.roomId,
      //         text: x.i18ns.find(x => x.lang == this.systemLang).name
      //       });
      //     });
      //   } else {
      //     _alert(res, this.$t(res.data), false);
      //   }
      // });

      // let body_ota = {
      //   keyword: "",
      //   status: 1
      // };
      // await syncota.getAllOTA(body_ota).then(res => {
      //   if (res.responseCode === 0) {
      //     res.data.forEach(x => {
      //       this.listSelectOTA.push({
      //         value: x.id,
      //         text: x.otaI18n.find(y => y.lang == this.systemLang).name
      //       });
      //     });
      //   } else {
      //     _alert(res, this.$t(res.data), false);
      //   }
      // });

      // let body_roomplan = {
      //   keyword: "",
      //   status: null,
      //   limit: 1000,
      //   offset: 0,
      //   orderBy: "active",
      //   asc: false
      // };
      // salePackageService.getAllPlan(body_roomplan).then(res => {
      //   if (res.responseCode === 0) {
      //     res.data.forEach(x => {
      //       this.listSelectRoomPlan.push({
      //         value: x.id,
      //         text: x.i18ns.find(y => y.lang == this.systemLang).name
      //       });
      //     });
      //   } else {
      //     _alert(res, this.$t(res.data), false);
      //   }
      // });
      this.getAllRoomDefault();
      // await this.searchLog(1);
    },
    _moment: moment,
    searchLog(value) {
      this.isLoading = true;
      let body = {
        roomTypeId: this.selectedRoomType,
        ratePlanId: this.selectedRoomPlan,
        otaId: this.selectedOTA,
        // function: this.selectedFunction,
      };

      body.limit = this.paging.limit;
      body.offset = value === 1 ? 0 : this.paging.offset;
      body.appliedDate = this.selectedDatePicker;

      log.getLogOta(body).then((res) => {
        this.dataTable = res.data.map((logData) => {
          if (logData.data.updated_i18n) {
            logData.data.i18ns = logData.data.updated_i18n
              .split("EZ_CMS_SPLIT;")
              .map((i18n) => JSON.parse(i18n));
          }
          return logData;
        });
        this.paging.total = res.total;
        this.isLoading = false;
      });
    },
    changePage(paging) {
      this.paging = paging;
      this.searchLog(this.paging.offset);
    },
    getKeyWordLog(key, value) {
      let keyString = "";
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(key)) {
        keyString = key;
      } else {
        keyString = this.$t(`HOTEL_LOG_${key}`);
      }
      return `<strong>${keyString}</strong> : ${value}`;
    },
    parseLogData(logJson) {
      try {
        if (
          typeof logJson !== "undefined" &&
          logJson !== null &&
          logJson !== ""
        ) {
          const logData = JSON.parse(logJson);
          const outPut = this.parseChildData(logData, true);

          return outPut;
        }
        return logJson;
      } catch (e) {
        return null;
      }
    },
    parseChildData(data, first = false) {
      let logStringOut = "";
      if (!first) {
        logStringOut += "<br/>";
        logStringOut += "<div class='ml-4'>";
      }
      for (const prop in data) {
        if (typeof data[prop] === "object") {
          logStringOut += this.getKeyWordLog(
            prop,
            this.parseChildData(data[prop])
          );
        } else {
          logStringOut += `${this.getKeyWordLog(prop, data[prop])}<br/>`;
        }
      }
      if (!first) {
        logStringOut += "</div>";
      }
      return logStringOut;
    },
  },
};
</script>

<style>
.download-button:hover {
  text-decoration: none;
}
</style>
